module.exports = __webpack_public_path__ + "img/EAEAEA_B5B5B5_CCCCCC_D4D4D4-256px.39ef38dc.png";